import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";

export class CompetitorPlayersStatsModuleProps extends BaseModuleProps {
  controller: CompetitorPlayersStatsModuleController;
  gameId: Number;
  location: Location;
  source: String;
  selectedAthleteId: Number;
  competitorId: Boolean;
  onClose: Function;
  shouldFetchData:Boolean;
}
